// AppHeader.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './AppHeader.css';

const AppHeader = () => {
  const { t, i18n } = useTranslation();

  return (
    <header>
      <nav>
        <h1>{t('message.appTitle')}</h1>
        <ul>
          <li><Link to="/">{t('message.home.title')}</Link></li>
          <li><Link to="/product">{t('message.product.title')}</Link></li>
          <li><Link to="/contact">{t('message.contact.title')}</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default AppHeader;
